<div *ngIf="!loader" class="h-full flex flex-col bg-gradient-to-t from-stone-100 to-white">

  <app-header-order [redirectPage]="'product'"></app-header-order>

  <!-- Banner point of sale -->
  <div class="px-4 pt-4 xl:px-0">
    <div class="w-full rounded-lg bg-center bg-no-repeat bg-cover transition-all
             h-[105px] md:h-[250px] xl:h-[300px]" [style.background-image]="
        'url(' +
        (currPos && currPos.banner
          ? (currPos.banner | prodSizeFilter: 1920)
          : 'assets\img\banners\restaurant.jpg') +
        ')'
      "></div>
  </div>

  <!-- Main -->"
  <div class="flex items-center justify-center flex-1" #main_container *ngIf="currPos">
    <div class="flex flex-row w-full lg:w-[1200px] h-full px-4 xl:px-0">

      <div class="flex-1">

        <!-- POS card -->
        <div class="bg-white rounded-2xl shadow p-4 md:p-6 mb-4 mt-4 xl:-mt-8">

          <div class="flex gap-6">

            <div *ngIf="currPos.img" class="md:block shrink-0">
              <img class="w-24 h-24 rounded-xl object-cover" [src]="currPos.img" [alt]="currPos.denomination" />
            </div>

            <div class="flex flex-col">

              <div class="mb-4">
                <span class="text-lg sm:text-2xl text-gray-800 uppercase font-bold fontPoppins">
                  {{ currPos.denomination }}
                </span>
              </div>

              <div class="flex flex-col">

                <div class="flex items-center mb-1 text-sm text-gray-800 font-semibold">
                  <i class="material-icons text-indigo-500 mr-2">location_on</i>
                  <span>
                    {{ currPos.address | uppercase }} - {{ currPos.postal }} {{ currPos.city | uppercase }}
                  </span>
                </div>

                <div class="flex items-center mb-2 text-sm text-gray-800 font-semibold">
                  <i class="material-icons text-indigo-500 mr-2">phone</i>
                  <span *ngIf="currPos.phone">{{ currPos.phone }}</span>
                </div>

              </div>
            </div>

          </div>
        </div>

        <!-- Sale methods -->
        <div class="bg-white rounded-2xl shadow p-4 md:p-6 mb-6">
          <div class="flex items-center justify-between mb-4">
            <h2 class="text-lg font-semibold text-gray-800">
              {{ 'saleMethod.choose' | translate }}
            </h2>
          </div>

          <div *ngIf="saleMethods.length; else noSm" class="grid grid-cols-1 sm:grid-cols-2 gap-3">

            <button type="button" *ngFor="let sm of saleMethods" class="w-full text-left p-4 rounded-2xl bg-white border border-gray-200
                     shadow-sm hover:shadow-md hover:border-gray-300 transition
                     disabled:opacity-50 disabled:cursor-not-allowed" [disabled]="!canSelect(sm)"
              (click)="selectSm(sm)">
              <div class="flex items-start justify-between gap-3">
                <div>
                  <div class="text-base font-semibold text-gray-900">
                    {{ sm.name }}
                  </div>

                  <div *ngIf="sm.descriptionOrder" class="text-sm text-gray-600 mt-1">
                    {{ sm.descriptionOrder }}
                  </div>

                  <div *ngIf="sm.enableDateHour === true" class="mt-3">
                    <ng-container *ngIf="nextSlotBySmId[sm.id] as info" [ngSwitch]="info.kind">

                      <span *ngSwitchCase="'NOW'" class="text-xs px-2 py-1 rounded-full bg-emerald-50 text-emerald-700">
                        Commandez maintenant ({{ info.at | date:'HH:mm' }})
                      </span>

                      <span *ngSwitchCase="'NEXT'" class="text-xs px-2 py-1 rounded-full bg-indigo-50 text-indigo-700">
                        Prochain créneau :
                        {{ info.at | date:'EEEE HH:mm' }}
                      </span>

                      <span *ngSwitchCase="'NONE'" class="text-xs px-2 py-1 rounded-full bg-red-50 text-red-700">
                        Indisponible
                      </span>

                    </ng-container>
                  </div>
                </div>

                <i class="material-icons text-indigo-500">chevron_right</i>
              </div>
            </button>

          </div>

          <ng-template #noSm>
            <div class="text-sm text-gray-600">
              {{ 'saleMethod.noneAvailable' | translate }}
            </div>
          </ng-template>
        </div>

        <app-footer-client class="w-full"></app-footer-client>

      </div>
    </div>
  </div>
</div>

<app-fulle-page-loader [loader]="loader" [pointOfSale]="currPos" fxFlexFill>
</app-fulle-page-loader>

<app-popup-loader [flagLoading]="loaderpop" [size]="30" [statusMessage]="statusMessage"
  [transparent]="loaderTransparent">
</app-popup-loader>